import { Layout } from "antd";

export const Footer = () => {
  return (
    <Layout.Footer style={{ textAlign: "center" }}>
      © 2024 Vitria Technology, inc.
    </Layout.Footer>
  );
};